import { render } from "./CatalogProductCard.vue?vue&type=template&id=d240b4a2&scoped=true"
import script from "./CatalogProductCard.vue?vue&type=script&lang=js"
export * from "./CatalogProductCard.vue?vue&type=script&lang=js"

import "./CatalogProductCard.vue?vue&type=style&index=0&id=d240b4a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d240b4a2"]])

export default __exports__